import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-two',
  templateUrl: './funfacts-style-two.component.html',
  styleUrls: ['./funfacts-style-two.component.scss']
})
export class FunfactsStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
